import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { userIdentityShape, ugcVideoShape, bibShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import { UGC_CONTENT_TYPES } from '@bibliocommons/constants-ugc';
import { supportsUGCContentType } from '@bibliocommons/utils-ugc';
import VideoDisplay from '../../../shared/UGC/VideoDisplay';

export default class ShelfListItemVideoInfo extends BcReactComponent {
  render() {
    const {
      bib,
      item,
      owner,
      currentLibrary,
      localBranch,
      ownerVideoForBib,
      videosTransactions,
      shelfTransactions,
      videosActions,
      shelfActions
    } = this.props;

    if (ownerVideoForBib && supportsUGCContentType(UGC_CONTENT_TYPES.VIDEO, currentLibrary, localBranch)) {
      return (
        <div className="cp-shelf-list-item-video-info">
          <VideoDisplay
            bib={bib}
            shelfItem={item}
            video={ownerVideoForBib}
            owner={owner}
            videosTransactions={videosTransactions}
            shelfTransactions={shelfTransactions}
            videosActions={videosActions}
            shelfActions={shelfActions} />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemVideoInfo.propTypes = {
  bib: bibShape.isRequired,
  currentLibrary: ImmutablePropTypes.map.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  ownerVideoForBib: ugcVideoShape,
  videosTransactions: ImmutablePropTypes.map,
  videosActions:PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/VideoInfo/VideoInfo.jsx